import { render, staticRenderFns } from "./ucenter_jbxx.vue?vue&type=template&id=6b8fbc50"
import script from "./ucenter_jbxx.vue?vue&type=script&lang=js"
export * from "./ucenter_jbxx.vue?vue&type=script&lang=js"
import style0 from "./ucenter_jbxx.vue?vue&type=style&index=0&id=6b8fbc50&prod&lang=css"
import style1 from "./ucenter_jbxx.vue?vue&type=style&index=1&id=6b8fbc50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports